import { useTranslation } from 'react-i18next';
import {
  ColumnsPanelTrigger,
  GridViewColumnIcon,
  Toolbar,
  ToolbarButton,
} from '@mui/x-data-grid-pro';
import { ThemeProvider } from '@mui/material/styles';
import { customToolbarButtonTheme } from 'assets/styles/themes/generic_button_mui';
import { Button as MButton } from '@mui/material';
import { COLORS, IMPORT_TYPE } from 'utils/GlobalVariables';
import { CustomToolBarExportButton } from './CustomToolBarExportButton';

export const CustomToolBarMappingDatagrid = ({
  handleMappingTypeChange,
  selectedMappingType,
  setModalCreateOpen,
  from = 'mappingCulture',
}) => {
  const { t } = useTranslation();
  return (
    <Toolbar>
      <ColumnsPanelTrigger render={<ToolbarButton />}>
        <GridViewColumnIcon fontSize="small" />
      </ColumnsPanelTrigger>
      <CustomToolBarExportButton from={from} selectedMappingType={selectedMappingType} />
      <div style={{ flex: 1 }} />
      <div className="d-flex justify-space-between">
        <ThemeProvider theme={customToolbarButtonTheme}>
          {from === 'mappingCulture' ? (
            <MButton onClick={() => setModalCreateOpen(true)}>{t('title.addCulture')}</MButton>
          ) : (
            <MButton onClick={() => setModalCreateOpen(true)}>{t('title.addGroundType')}</MButton>
          )}
          <MButton
            onClick={() => handleMappingTypeChange(IMPORT_TYPE.geofolia)}
            sx={{
              backgroundColor: selectedMappingType === IMPORT_TYPE.geofolia ? COLORS.yellow : '',
            }}
          >
            Data Geofolia
          </MButton>
          {from === 'mappingCulture' && (
            <MButton
              onClick={() => handleMappingTypeChange(IMPORT_TYPE.telepac)}
              sx={{
                backgroundColor: selectedMappingType === IMPORT_TYPE.telepac ? COLORS.yellow : '',
              }}
            >
              Data Telepac
            </MButton>
          )}
          {from === 'mappingCulture' && (
            <MButton
              onClick={() => handleMappingTypeChange(IMPORT_TYPE.apia)}
              sx={{
                backgroundColor: selectedMappingType === IMPORT_TYPE.apia ? COLORS.yellow : '',
              }}
            >
              Data Apia
            </MButton>
          )}
          <MButton
            onClick={() => handleMappingTypeChange(IMPORT_TYPE.wiuz)}
            sx={{
              backgroundColor: selectedMappingType === IMPORT_TYPE.wiuz ? COLORS.yellow : '',
            }}
          >
            Data Wuiz
          </MButton>
        </ThemeProvider>
      </div>
    </Toolbar>
  );
};
